module.exports = __webpack_public_path__ + "images/178_640.jpg";